import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Parties from "@/pages/Parties";
import PartyDetail from "@/pages/PartyDetail";
import Promises from "@/pages/Promises";
import Polls from "@/pages/Polls";
import Statistics from "@/pages/Statistics";
import Articles from "@/pages/Articles";
import Quiz from "@/pages/Quiz";
import Compare from "@/pages/Compare";
import Politicians from "@/pages/Politicians";
import PoliticianDetail from "@/pages/PoliticianDetail";
import Admin from "@/pages/Admin";
import CookiePolicy from "@/pages/CookiePolicy";
import CookieBanner from "@/components/CookieBanner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Navbar />
                <main className="min-h-[70vh]">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/partier" element={<Parties />} />
                        <Route path="/partier/:id" element={<PartyDetail />} />
                        <Route path="/politikere" element={<Politicians />} />
                        <Route path="/politikere/:id" element={<PoliticianDetail />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/lofter" element={<Promises />} />
                        <Route path="/afstemninger" element={<Polls />} />
                        <Route path="/statistik" element={<Statistics />} />
                        <Route path="/artikler" element={<Articles />} />
                        <Route path="/quiz" element={<Quiz />} />
                        <Route path="/sammenlign" element={<Compare />} />
                        <Route path="/cookies" element={<CookiePolicy />} />
                    </Routes>
                </main>
                <Footer />
                <CookieBanner />
            </BrowserRouter>
        </div>
    );
}

export default App;
